// File#: _1_compensation_calculator.js

(function () {
    const calculator = document.querySelector('.block__compensation-calculator');
    if (!calculator) return;

    const slider = calculator.querySelector('#sliderValue');
    const inputValue = calculator.querySelector('.js-slider__value');
    const resultContentElements = calculator.querySelectorAll('.js-result');

    // Min/Max input values calculator will consider
    const allowanceMinValue = 14025;
    const allowanceMaxValue = 33000;

    // Helper Functions
    function removeBlankSpace(value) {
        return parseInt(value.replace(/\s+/g, ''), 10);
    }

    function getResult(formelPercent) {
        let income = removeBlankSpace(slider.value);
        income = Math.max(allowanceMinValue, Math.min(income, allowanceMaxValue));
        return Math.round((income * parseFloat(formelPercent)) / 22);
    }

    function setResultContent(elementIndex, result, maxValue) {
        if (maxValue && result > maxValue) {
            result = maxValue;
        }
        if (resultContentElements[elementIndex]) {
            resultContentElements[elementIndex].value = result;
        }
    }

    // Main Calculation Logic
    function updateResult() {
        setResultContent(0, 0); // Reset for Days 1-2
        setResultContent(1, getResult('.8'), 1200); // Days 3-100
        setResultContent(2, getResult('.8'), 1000); // Days 101-200
        setResultContent(3, Math.max(510, getResult('.7')), 1000); // Days 201-300
    }

    function setupEventListeners() {
        slider.addEventListener('input', updateResult);

        inputValue.addEventListener('input', function () {
            slider.value = this.value.trim() === '' ? 0 : Math.max(0, Math.min(parseInt(this.value, 10) || 0, slider.max));
            updateResult();
        });

        // Trigger updateResult at least once to initialize values based on the current slider position.
        updateResult();
    }

    setupEventListeners();
})();